<finxone-web-frontend-desktop-listing
  [entityData]="paymentHistoryData"
  [actionOptions]="actionOptions"
  [dataIn]="dataIn"
  [pageNumber]="pageNumber"
  [entityName]="entityName"
  [totalListCount]="totalListCount"
  [isShowOption]="isShowOption"
  [isShowMoreOption]="isShowMoreOption"
  (pageChange)="onPageChange($event)"
  emptyTableMsg="No History Found"
  (performAction)="performAction($event)"
  [menuPopupCss]="menuPopupCss"
  (searchValueText)="searchValue($event)"
></finxone-web-frontend-desktop-listing>
